module.exports = __webpack_public_path__ + "static/media/Gallery.9fea34b1.png";